import { useLocalStorageState } from '@frontend/common';
import { SettingKey } from '@frontend/setting/types';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '../redux/store';
import { MOBILE_TEMPORARY_LOCATION_KEY, MobileTemporaryLocation, getTemporaryLocationSpotId } from './mobile-temporary-location';

/**
 * Resolves the user's current spot_id for mobile wizards and lists.
 *
 * Priority:
 * 1. Valid temporary SPOT (5-minute TTL; does not overwrite durable device location)
 * 2. Wizard data `location_spot_id` (e.g. identify-current-location)
 * 3. Durable `mobile-current-location`
 * 4. Functionality `DEFAULT_SPOT_ID` when inside a wizard
 */
const useCurrentLocation = () => {
    const store = useAppSelector((state) => state);
    const [location] = useLocalStorageState<string | null>('mobile-current-location', null);
    const [temporaryLocation] = useLocalStorageState<MobileTemporaryLocation | null>(MOBILE_TEMPORARY_LOCATION_KEY, null);

    const { wizardId } = useParams<{ wizardId: string }>();
    const functionalityLocation =
        store.wizards && wizardId
            ? (store.wizards[wizardId].functionalitySettings.find((s) => s.key === SettingKey.DEFAULT_SPOT_ID)?.value as string | undefined | null)
            : undefined;

    const wizardDataLocation = store.wizards && wizardId ? (store.wizards[wizardId]?.data?.location_spot_id as string | undefined | null) : undefined;

    const temporarySpotId = getTemporaryLocationSpotId(temporaryLocation);
    const currentLocation = temporarySpotId || wizardDataLocation || location || functionalityLocation || undefined;

    return {
        spot_id: currentLocation
    };
};

export default useCurrentLocation;
